import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Course {
  id: string;
  title: string;
  description: string;
  progress: number;
}

interface CourseState {
  courses: Course[];
  currentCourse: Course | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: CourseState = {
  courses: [],
  currentCourse: null,
  isLoading: false,
  error: null
};

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    setCourses: (state, action: PayloadAction<Course[]>) => {
      state.courses = action.payload;
      state.error = null;
    },
    setCurrentCourse: (state, action: PayloadAction<Course>) => {
      state.currentCourse = action.payload;
    },
    clearCourses: (state) => {
      state.courses = [];
      state.currentCourse = null;
    },
    setCourseError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    }
  }
});

export const { setCourses, setCurrentCourse, clearCourses, setCourseError } = courseSlice.actions;
export default courseSlice.reducer;